import { createIntl } from "@formatjs/intl";
import $ from "jquery";

import { confirmAsync } from "../components/ConfirmDialog";
import { defaultLocale, localizedMessages } from "../locales";

// Override the default confirm dialog by jquery-ujs
$.rails.allowAction = (link) => {
  const title = link.attr("data-confirm");
  if (!title) {
    return true;
  }

  const intlConfig = {
    locale: defaultLocale,
    messages: localizedMessages[defaultLocale],
  };
  const okButtonLabel =
    link.attr("data-confirmButtonText") == null
      ? createIntl(intlConfig).formatMessage({ id: "shared.verbs.remove" })
      : link.attr("data-confirmButtonText");
  const content = link.attr("data-text");
  const closeOnConfirm = typeof link.attr("data-close") !== "undefined";
  const okButtonClassName = link.attr("data-confirmOkButtonClassName") || "is-button-warning";

  confirmAsync({
    intl: intlConfig,
    title,
    content,
    okButtonClassName,
    okButtonLabel,
    closeOnConfirm,
  }).then((isConfirmed) => {
    if (isConfirmed) {
      link.removeAttr("data-confirm");
      link.trigger("click.rails");
    }
  });
  return false;
};
